export const ACCOUNT_USERS_LIST_URL: string = 'account/{accountId}/users';
export const ACCOUNT_USERS_EXPORT_URL: string = 'user/account-users/{accountId}/export';